export default {
  init() {

    /**
     * Affiche le pluriel d'un type
     * @param {int} nb
     */
    function pluriel(nb){
      return (nb === 1) ? '' : 's';
    }
    /**
     * Affiche le résultat de la recherche
     * @param {*} element
     * @param {*} index
     */
    function setResult(element,index){
      return (element > 0) ? '<a href="#" class="js-search-type" data-target="'+index+'">' + element + ' ' + index + pluriel(element) + '</a>' : '';
    }

    const searchtypes = {
      'membre' : $('.c-card-post-type-membre').length,
      'article' : $('.c-card-post-type-article').length,
      'page' : $('.c-card-post-type-page').length,
      'événement' : $('.c-card-post-type-evenement').length,
      'document' : $('.c-card-post-type-document').length,
    };

    let resultats = [];

    $.each(searchtypes, function( key, value ) {
        resultats.push( setResult(value,key) );
    });

    resultats = resultats.filter(item => item);
    resultats = resultats.join(', ');

    const search_counter = `Nous avons trouvé : ${resultats}.`;

    if( $('.search-results .container').length ){

      $('.page__header-image').after('<div class="text-base pb-2">' + search_counter +'</div>');

    }

    $(document).on('click', '.js-search-type' , function() {
       const target = $(this).attr('data-target');
       const targetEl = $('.c-card-post-type-' + target + ':first');
      console.log(targetEl);

      $('html, body').animate({
        scrollTop: targetEl.offset().top,
      }, 1000);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search.js